import type { MetricItem } from '@/types/api/dashboard'

interface NumberCardWidgetProps {
  title: string
  metrics?: MetricItem[]
}

const GRADIENTS = [
  'from-blue-500 to-indigo-500',
  'from-emerald-500 to-teal-500',
  'from-purple-500 to-violet-500',
  'from-rose-500 to-pink-500',
  'from-amber-500 to-orange-500',
  'from-cyan-500 to-blue-500',
]

export function NumberCardWidget({ title, metrics = [] }: NumberCardWidgetProps) {
  const metric = metrics[0]
  const gradientIndex = title.length % GRADIENTS.length
  const gradient = GRADIENTS[gradientIndex]

  return (
    <div className="flex h-full flex-col justify-center p-5">
      <div className={`inline-flex rounded-lg bg-gradient-to-r ${gradient} p-[1px] shadow-sm`}>
        <div className="flex flex-1 flex-col rounded-[7px] bg-white px-5 py-4">
          <p className="text-xs font-semibold uppercase tracking-wider text-neutral-500">{title}</p>
          <p className="mt-2 text-3xl font-bold tracking-tight text-neutral-900">{metric?.value ?? '—'}</p>
          {metric?.label ? <p className="mt-0.5 text-xs text-neutral-400">{metric.label}</p> : null}
        </div>
      </div>
    </div>
  )
}
